export default __webpack_public_path__ + "static/media/Incidents-3.85640bf7.png";